import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

export const ITEMS_PER_PAGE = 10;

// Flat pagination (not PG's per-month-group pagination in ViewLogbooks.js —
// UG review screens aren't grouped by month) over an already-filtered list.
const Pagination = ({ currentPage, totalCount, onPageChange }) => {
  const totalPages = Math.max(1, Math.ceil(totalCount / ITEMS_PER_PAGE));
  if (totalPages <= 1) return null;
  return (
    <div className="ugtr-pagination">
      <button
        className="ugtr-page-btn"
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
      >
        <FaChevronLeft /> Prev
      </button>
      <span className="ugtr-page-info">
        Page {currentPage} of {totalPages}
        <span className="ugtr-page-total"> ({totalCount} entries)</span>
      </span>
      <button
        className="ugtr-page-btn"
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      >
        Next <FaChevronRight />
      </button>
    </div>
  );
};

export default Pagination;
